import {
  getPocScriptDownloadFilename,
  POC_SCRIPT_MIME_TYPE,
} from '@terra/shared-contracts-findings';
import { downloadContentAsFile } from './download-content.utils';

export function downloadPocScriptAsFile({
  pocScript,
  findingId,
}: {
  pocScript: string;
  findingId: string;
}): void {
  downloadContentAsFile({
    content: pocScript,
    filename: getPocScriptDownloadFilename({ findingId }),
    mimeType: POC_SCRIPT_MIME_TYPE,
  });
}
